import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Sparkles, RefreshCw } from "lucide-react";

export function AdvisorCard({ period, branchParam }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const load = () => {
    setLoading(true); setErr("");
    api.get("/reports/owner-dashboard/advisor", { params: { period, branch_id: branchParam } })
      .then((r) => setData(r.data)).catch(() => setErr("Advisor unavailable right now."))
      .finally(() => setLoading(false));
  };
  useEffect(load, [period, branchParam]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card className="p-5 bg-card border-border relative overflow-hidden" data-testid="win-advisor">
      <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-primary/10 blur-3xl pointer-events-none" />
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-sm bg-primary/15 flex items-center justify-center text-primary"><Sparkles size={16} /></div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">Dynamic AI Business Advisor</p>
            <p className="text-xs text-muted-foreground">{data?.source === "ai" ? "AI analysis of your actual business data" : data ? "Data-driven suggestions" : ""}</p>
          </div>
        </div>
        <Button size="sm" variant="ghost" onClick={load} disabled={loading} data-testid="advisor-refresh" className="h-8 rounded-sm text-muted-foreground">
          <RefreshCw size={14} className={`mr-1 ${loading ? "animate-spin" : ""}`} /> {loading ? "Analysing…" : "Refresh"}
        </Button>
      </div>
      {err && <p className="text-sm text-destructive" data-testid="advisor-error">{err}</p>}
      {!data && loading && <p className="text-sm text-muted-foreground">Analysing bills, expenses, staff and collections…</p>}
      {data && (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
          {data.suggestions.map((s, i) => (
            <div key={i} data-testid={`advisor-item-${i}`} className="rounded-sm border border-border bg-secondary/30 p-4 flex flex-col gap-2 animate-in fade-in slide-in-from-bottom-2" style={{ animationDelay: `${i * 80}ms`, animationFillMode: "both" }}>
              <p className="font-display text-2xl text-primary leading-none">{s.figure}</p>
              <p className="text-sm font-medium leading-snug">{s.title}</p>
              <p className="text-xs text-muted-foreground leading-snug">{s.insight}</p>
              <p className="text-xs mt-auto pt-2 border-t border-border/60"><span className="text-primary">Do: </span>{s.action}</p>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
